import {
    Dispatch,
    Reducer,
    ReducerAction,
    ReducerState,
    useCallback,
    useEffect,
    useMemo,
    useRef,
    useState,
} from 'react';
import { runSaga, Saga, stdChannel } from 'redux-saga';

import { useStableCallback } from './useStableCallback';

// eslint-disable-next-line @typescript-eslint/ban-types
type NotUndefined = {} | null; // from @redux-saga/types

export function useSagaReducer<S, A extends NotUndefined, R extends Reducer<S, A>, Args extends unknown[] = unknown[]>(
    reducer: R,
    initialState: ReducerState<R>,
    saga: Saga<Args>
): [ReducerState<R>, Dispatch<ReducerAction<R>>] {
    const env = useRef(initialState as S);
    const getState = useCallback(() => env.current, []);
    const channel = useMemo(() => stdChannel<A>(), []);
    const [state, setState] = useState(initialState);
    const stableReducer = useStableCallback(reducer);

    const dispatch = useCallback(
        //@ts-ignore - EDUCATION-37077: [react-update]: fixme typings: ???
        (a) => {
            env.current = stableReducer(env.current, a);
            setState(env.current as ReducerState<R>);
            channel.put(a);
        },
        [channel, stableReducer]
    );

    useEffect(() => {
        const task = runSaga<A, S, Saga>({ channel, dispatch, getState }, saga);

        return () => task.cancel();
    }, [channel, dispatch, getState, saga]);

    return [state, dispatch];
}
